<template>
  <div class="mpf-grid-row" v-if="layoutPageTitle || resolvedLayoutPageTitle">
    <div class="mpf-grid-column-full">
      <h1 class="mpf-heading-l">{{ resolvedLayoutPageTitle ?? layoutPageTitle }}</h1>
    </div>
  </div>
  <slot />
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router';
  import { computed } from 'vue';
  import { useRouteMetaOverrideStore } from '../../stores/useRouteMetaOverrideStore';

  const route = useRoute();
  const metaOverride = useRouteMetaOverrideStore();

  const layoutPageTitle = computed(() => {
    const matched = route.matched;
    if (!matched.length) return null;

    const deepest = matched[matched.length - 1];

    if ('layoutPageTitle' in deepest.meta) {
      return (deepest.meta.layoutPageTitle ?? null) as string | null;
    }

    for (let i = matched.length - 2; i >= 0; i--) {
      const value = matched[i].meta.layoutPageTitle;
      if (typeof value === 'string' && value.length > 0) {
        return value;
      }
    }
    return null;
  });

  const resolvedLayoutPageTitle = computed(() => {
    return metaOverride.layoutPageTitle ?? (route.meta.layoutPageTitle as string | undefined) ?? '';
  });
</script>
